import script from "./VoiceRecordingAnchor.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceRecordingAnchor.vue?vue&type=script&setup=true&lang=js"

import "./VoiceRecordingAnchor.vue?vue&type=style&index=0&id=33c5c63a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c5c63a"]])

export default __exports__